export default {"src":"/_next/static/media/infoIconCircleBlack_24.b1ebbb7c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};